<template>
    <section id="content-revenue" class="content-revenue">
        <h2>Revenue</h2>
        <v-tabs
            v-model="selectedTab"
            slider-color="#606060"
            slider-size="3"
            background-color="#E6E6E6">
                <v-tab
                    id="content-revenue-historical"
                    key="historical"
                    class="tab_bg_color">
                    Historical Revenue
                </v-tab>
                <v-tab
                    id="content-revenue-breakdown"
                    key="breakdown"
                    class="tab_bg_color">
                    Revenue Breakdown
                </v-tab>
                <v-tab
                    id="content-revenue-other"
                    key="other"
                    class="tab_bg_color">
                    Other Revenue Details
                </v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectedTab" class="v-tabs-items content-revenue pa-0 ma-0">
            <v-tab-item key="historical" eager class="content-revenue historical_padding">
                <RevenueHistorical
                    :recurringPercent="listing.revenue_percent_recurring"
                    :historicalRevenue="historicalRevenue"
                    :listing="listing" />
            </v-tab-item>
            <v-tab-item key="breakdown" class="content-revenue breakdown_padding">
                <RevenueBreakdown
                    :listing="listing" />
            </v-tab-item>
            <v-tab-item key="other" eager class="content-revenue other_padding">
                <RevenueOther
                    :insuranceBasedListings="insuranceBasedListings"
                    :practiceType="listing.listing_type"
                    :billingCycle="listing.revenue_billing_cycle"
                    :aumManagement="listing.revenue_management_aum"
                    :financialPlans="listing.revenue_financial_plans"
                    :averageFee="listing.revenue_average_fee_charged"
                    :familyAccounts="listing.revenue_family_accounts"
                    :openEnrollment="listing.revenue_open_enrollment"
                    :otherNotes="listing.revenue_other_notes" />
            </v-tab-item>
        </v-tabs-items>
    </section>
</template>

<script>
import dateformat from 'dateformat'

import RevenueOther from './section-revenue/RevenueOther'
import RevenueBreakdown from './section-revenue/RevenueBreakdown'
import RevenueHistorical from './section-revenue/RevenueHistorical'

export default {
    name: 'DetailsRevenueInformation',
    components: {
        RevenueOther,
        RevenueBreakdown,
        RevenueHistorical,
    },

    props: {
        activeSection: String,
        insuranceBasedListings: Array,
        listing: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        selectedTab: 0,
        tabs: [
            'content-revenue-other',
            'content-revenue-breakdown',
            'content-revenue-other'
        ],
    }),

    computed: {
        revenueHourly () {
            return (
                (Number(this.listing.revenue_hourly_recurring) || 0) +
                (Number(this.listing.revenue_hourly_transactional) || 0)
            )
        },

        revenueTrails () {
            return (
                (Number(this.listing.revenue_12b1s_recurring) || 0) +
                (Number(this.listing.revenue_trails_recurring) || 0)
            )
        },

        historicalRevenue () {
            let combinedRevenue = [
                ...Object.entries(this.listing.revenue_historical).map(([year, revenue]) => ({
                    year: Number(year),
                    revenue,
                }))
            ];

            if ( this.listing.revenue_t12_asof_date ) {
                combinedRevenue.push( { year: `T12*`, revenue: this.listing.revenue_t12_months } )
            }

            if ( this.listing.revenue_projected ) {
                combinedRevenue.push( { year: [`Projected`, Number(dateformat((new Date(this.listing.revenue_t12_asof_date)), 'yyyy'))], revenue: this.listing.revenue_projected } )
            }

            return combinedRevenue
                .sort(({ year: a }, { year: b }) => b - a)
                .slice(0, 8)
        },
    },

    watch: {
        activeSection (oldVal, newVal) {
            if (oldVal === newVal) return

            const tab = this.tabs.indexOf(this.activeSection)
            if (tab > -1) this.selectedTab = tab
        },
    }
}
</script>

<style scoped>
    .content-revenue {
        background-color: #EFEFEF !important;
    }

    .historical_padding {
        background-color: #EFEFEF;
        padding: 20px 0 10px 0;
    }
    .breakdown_padding {
        background-color: #EFEFEF;
        padding: 40px 0 10px 0;
    }
    .other_padding {
        background-color: #EFEFEF;
        padding: 40px 0 20px 0;
    }

    .tab_bg_color {
        background-color: #E6E6E6;
    }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/RevenueInformation.vue